<template>
  <div class="s-paginator-skeleton">
    <PSkeleton height="30px" width="80px" />
    <div class="s-paginator-skeleton__pages">
      <PSkeleton height="40px" width="40px" />
      <PSkeleton height="40px" width="40px" />
      <PSkeleton height="40px" width="40px" />
      <PSkeleton height="40px" width="40px" />
    </div>
    <PSkeleton height="30px" width="80px" />
  </div>
</template>

<script setup lang="ts">
/**
 * Loading skeleton placeholder for SPaginator component.
 * Shows prev/next button skeletons and 4 page number placeholders.
 */
import PSkeleton from "@/atoms/PSkeleton.vue";
</script>

<style scoped lang="postcss">
.s-paginator-skeleton {
  @apply my-5 flex w-full items-center justify-between gap-2;

  &__pages {
    @apply flex justify-center gap-1;
  }
}
</style>
